/* script */

  import {
    FILTER_EXPRESSION_OPERATORS,
    SEARCH_ALLVALUE,
  }                                            from 'g3w-constants';
  import ApplicationState                      from 'g3w-state';
  import GUI                                   from 'g3w-app';    
  import { convertQGISDateTimeFormatToMoment } from 'utils/convertQGISDateTimeFormatToMoment';
  import { getDataForSearchInput }             from 'utils/getDataForSearchInput';
  import { getRelationLayerById }              from 'utils/getRelationLayerById';
  import { throttle }                          from 'utils/throttle';

  const __vue_script__ = {

    data() {
      return {
       state:      this.$options.service.state,
       autofilter: false, //@since 3.11.0
       allvalue:   SEARCH_ALLVALUE,
       reload:     false,
      }
    },

    computed: {

      layers_url() {
        return ApplicationState.project.getState().layers_url;
      },

      is_staff() {
        return window.initConfig.user.is_staff;
      },

      /**
       * @since 3.11.0 loading inputs data
       * Disabled search form during loading input data
       * @return {*}
       */
      loading() {
        return this.state.forminputs.reduce((bool, i) => bool || i.loading, false);
      },

      /**
       * @TODO make use only of "this.state.search_layers" instead
       */
      search_layers() {
        return [].concat(getRelationLayerById(this.state.search_1n_relationid) || [], this.state.search_layers);
      },

      filterlayers() {
        return ApplicationState.tokens.filtertoken && this.search_layers.filter(l => l.getToken()) || [];
      },

    },

    methods: {
      /**
      * @since 3.11.0
      */
      clearFilters() {
        this.filterlayers.forEach(l => l.getToken() && l.clearSelectionFids());
        //@since v4.0 reset all form values after clear
        this.state.forminputs.forEach(i => {
          if (['selectfield','autocompletefield'].includes(i.type)) {
            i.value = 'in' === i.operator ? [i.values?.[0]?.value] : i.values?.[0]?.value; //set all or first value
          } else {
            i.value = null;
          }
          this.changeInput(i);
        })
        //@since 4.0.0 close content
        GUI.closeContent();
      },
      resize() {
        if (!ApplicationState.ismobile) {
          this.$el.querySelectorAll('x-select').forEach(select => select.close());
        }
      },

      /**
       * ORIGINAL SOURCE: src/components/SearchPanelLabel.vue@v3.9.3
       */
      getLabelOperator(operator) {
        return `[${FILTER_EXPRESSION_OPERATORS[operator]}]`;
      },

      async onFocus(e) {
        if (this.isMobile()) {
          const top = $(e.target).position().top - 10 ;
          await this.$nextTick();
          setTimeout(() => $('.main-sidebar').scrollTop(top), 500);
        }
      },

      /**
       * Sync `this.state.forminputs` with `input.value`
       */
      async changeInput(input) {
        const field  = input.attribute;                                           // current field name
        const deps   = this.state.forminputs.filter(i => field === i.dependance); // inputs that depend on the current one
        const state  = this.state;
        let value    = input.value;

        const is_empty         = v => [].concat(v).find(v => [SEARCH_ALLVALUE, null, undefined].includes(v)) || '' === v.toString().trim(); // whether father input can search on subscribers
        const has_autocomplete = i => 'autocompletefield' === i.type;

        try {
          this.state.searching = true;

          if ('numberfield' === input.type) {
            value = value || 0 === value ? value : null;
          }

          // fallback to default value → `SEARCH_ALLVALUE`
          if (undefined === value) {
            value = SEARCH_ALLVALUE;
          }

          /** @TODO check if it has one reason to trim  */
          if (!['textfield', 'textField'].includes(input.type)) {
            value = Array.isArray(value) ? value.map(v => v?.trim?.()) : value?.trim?.();
          }

          //in case of undefined or null, set to null
          input.value = value ?? null;

          // loop and update dependants
          await (Promise.allSettled(deps.map(async d => {

            // cache server data by filter (eg: "zone|eq|A")
            const filter = getDataForSearchInput.field({
              state,
              field,
              fields: [].concat(value).find(v => [SEARCH_ALLVALUE, undefined].includes(v)) //consider in value Array
                ? []
                : ['in' === input.operator //@since 4.0.0 consider in operator
                    ? `${field}|${input.operator}|(${[].concat(value).map( v => encodeURIComponent(v))})`
                    : [].concat(value).map(v => `${field}|${(input.operator || 'eq').toLowerCase()}|${encodeURIComponent(v)}`).join(`|OR,`)
                  ]
            });

            const cached = d.dvalues[filter];

            // In case of in operator
            if ( 'in' === d.operator && ['selectfield', 'autocompletefield'].includes(d.type)) {
              d.value  = [SEARCH_ALLVALUE];
            }

            //In case of no in operator
            if ( 'in' !== d.operator) {
              d.value  =  'selectfield' === d.type ? SEARCH_ALLVALUE : null;
            }

            d.values = Array.from(new Set([                                       // ensure uniques values
              ...(!has_autocomplete(d) && !is_empty(value) ? [d.values[0]] : []), // get first value (ALL_VALUE)
              ...(!has_autocomplete(d) && is_empty(value) ? d._values      : []), // parent has an empty value (eg. ALL_VALUE) → show all original values on subscriber
              ...(cached || []),                                                  // cached
            ]));

            // value is empty → disable dependants inputs
            d.disabled = is_empty(value) ? d.dependance_strict : false;

            // update nested dependencies
            if (this.state.forminputs.find(i => d.attribute === i.dependance)) {
              this.changeInput(d);
            }

            // dependents values are there → no need to perform further server requests
            if (has_autocomplete(d) || is_empty(value) || cached) {
              return;
            }

            state.loading[d.attribute] = true;

            // extract the value of the field to get filter data from the relation layer
            // set undefined because if it has a subscribed input with valuerelations widget

            /** @TODO use `getDataForSearchInput` instead ? */
            try {
              // get data for all searchable layers
              const data = await getDataForSearchInput({ state, layerid: d.alternativeuniquelayer, field: d.attribute, filter });
              // case value map
              if (!d.dependance_strict && 'selectfield' === d.type) {
                d._values.push(...d.values);
              }

              // set key value for select (!valuemap && !valuerelation)
              if (1 === d.values.length) {
                d.values.push(...data);
              }

              // exclude first element (ALL_VALUE)
              d.dvalues[filter] = d.values.slice(1);


            } catch(e) {
              console.warn(e);
            } finally {
              d.disabled                      = false;
              this.state.loading[d.attribute] = false;
            }
          })));
        } catch(e) {
          console.warn(e);
        } finally {
          this.state.searching = false;
          await this.$nextTick();
          this.syncSelectInputs();
        }
      },

      doSearch(e) {
        e.preventDefault();
        this.$options.service.run();
      },

      getSelectInputValue(input) {
        return [].concat(input.value ?? this.allvalue).map(value => this.getSelectInputOptionValue(value)).join(',');
      },

      getSelectInputOptionValue(value) {
        return null === value ? 'null' : `${value}`;
      },

      syncSelectInput(input) {
        const select = Array.from(this.$el.querySelectorAll('x-select[data-input-id]'))
          .find(select => select.dataset.inputId === `${input.id}`);
        if (!select?.container) { return; }
        if ('autocompletefield' === input.type && !select.container.querySelector('.search-select-status')) {
          const status = document.createElement('div');
          status.className = 'search-select-status';
          status.setAttribute('role', 'status');
          status.style.cssText = 'padding: 8px 12px; color: #444;';
          status.textContent = `${this.$t('Please enter')} ${this.getAutocompleteMinimum(input)} ${this.$t('or more characters')}`;
          select.container.appendChild(status);
        }
        const multiple = 'in' === input.operator;
        const values = [].concat(input.value ?? this.allvalue).map(value => this.getSelectInputOptionValue(value));
        const options = Array.from(select.container.querySelectorAll('x-option'));
        select.selected_options = [];
        options.forEach(option => option.removeAttribute('selected'));
        values.forEach(value => {
          const option = options.find(option => option.value === value);
          if (option) { select.select(option, { autoclose: false, emit: false }); }
        });
        if (multiple) {
          select.select(null, { autoclose: false, emit: false });
        } else if (!select.selected_options.length) {
          select.content.textContent = `${g3w?.gettext?.('Select') || 'Select'}...`;
        }
        select.setAttribute('value', multiple ? values.join(',') : values[0]);
      },

      syncSelectInputs() {
        this.state.forminputs.forEach(input => this.syncSelectInput(input));
      },

      onSelectInputChange(input, event) {
        if ('in' === input.operator) {
          const values = event.target.selected_options.map(option => option.value);
          input.value = values.at(-1) === this.allvalue
            ? [this.allvalue]
            : values.filter(value => value !== this.allvalue);
          if (!input.value.length) { input.value = [this.allvalue]; }
        } else {
          input.value = event.target.value;
        }
        this.changeInput(input);
      },

      clearAutocomplete(input) {
        input.value = this.allvalue;
        this.changeInput(input);
      },

      getAutocompleteMinimum(input) {
        const digits = Number(input.options.numdigaut);
        return Number.isFinite(digits) && digits > 0 ? digits : 2;
      },

      resetAutocompleteStatus(input, event) {
        if ('autocompletefield' !== input.type || !event.target.closest('.x-select-trigger')) { return; }
        const status = event.currentTarget.container?.querySelector('.search-select-status');
        if (status) {
          status.hidden = false;
          status.textContent = `${this.$t('Please enter')} ${this.getAutocompleteMinimum(input)} ${this.$t('or more characters')}`;
        }
      },

      searchAutocomplete(input, { target, detail: { value = '' } = {} }) {
        clearTimeout(input._xSelectSearchTimer);
        const request = input._xSelectSearchRequest = (input._xSelectSearchRequest || 0) + 1;
        if ('autocompletefield' !== input.type) { return; }
        const term = value.trim();
        const minimum = this.getAutocompleteMinimum(input);
        const status = target.container?.querySelector('.search-select-status');
        if (term.length < minimum) {
          if (status) {
            status.hidden = false;
            status.textContent = `${this.$t('Please enter')} ${minimum} ${this.$t('or more characters')}`;
          }
          return;
        }
        if (status) {
          status.hidden = false;
          status.textContent = this.$t('Searching ...');
        }

        input._xSelectSearchTimer = setTimeout(async () => {
          try {
            const results = await getDataForSearchInput({
              state: this.state,
              layerid: input.alternativeuniquelayer,
              field: input.attribute,
              suggest: `${input.attribute}|${term}`,
            });
            if (request !== input._xSelectSearchRequest) { return; }

            const selected = new Set([].concat(input.value ?? []).map(value => `${value}`));
            const retained = input.values.filter(option => selected.has(`${option.value}`));
            input.values = Array.from(new Map([...retained, ...results].map(option => [`${option.value}`, option])).values());
            await this.$nextTick();
            this.syncSelectInput(input);
            if (status) {
              status.hidden = results.length > 0;
              status.textContent = this.$t('No results');
            }
          } catch (error) {
            if (request === input._xSelectSearchRequest) {
              console.warn(error);
              if (status) { status.textContent = this.$t('Error Loading Data'); }
            }
          }
        }, 500);
      },

      /**
       * ORIGINAL SOURCE: src/components/SearchDatetime.vue@v3.9.3
       */
      async initDateTimeField(input) {
        if ('datetimefield' !== input.type) {
          return;
        }

        await this.$nextTick();

        input.options.format.fieldformat   = convertQGISDateTimeFormatToMoment(input.options.format.fieldformat);
        input.options.format.displayformat = convertQGISDateTimeFormatToMoment(input.options.format.displayformat);

        $(this.$refs[`date_${input.id}`]).datetimepicker({
          format:         input.options.format.displayformat,
          ignoreReadonly: true,
          locale:         ApplicationState.language || 'en',
        });

        $(this.$refs[`date_${input.id}`]).on("dp.change", () => {
          const newDate = $(`#${input.id}`).val();
          input.value = newDate.trim()
            ? moment(newDate, input.options.format.displayformat).format(input.options.format.fieldformat)
            : null;
          this.changeInput(input);
        });

        if (ApplicationState.ismobile) {
          setTimeout(() => document.getElementById(input.id)?.blur());
        }
      },

      async reloadSearchInputs() {
        if (this.reload) { return; }
        this.reload = true;
        await this.$nextTick();
        try {
          await this.$options.service.setInputs();
        } catch (error) {
          console.warn(error);
        } finally {
          this.reload = false;
          await this.$nextTick();
          this.syncSelectInputs();
        }
      }

    },
    watch: {
      //@since 3.11.0 Set state auto filter to a search result
      autofilter(bool = false) {
        this.state.autofilter.value = Number(bool); //0/1 instead true false
      }
    },

    async created() {
      this.delayResize   = this.resize ? throttle(this.resize.bind(this), this.delayTime) : null;
      GUI.on('resize', this.delayResize);

      //Listen change filtertoken on layer
      //Need to listen on each layer instead to watch ApplicationState.tokens.filtertoken changes
      //because when create a new filter with new rules, the filtertoken string doesn't change
      this.search_layers.forEach(l => l.on('filtertokenchange', this.reloadSearchInputs));
    },

    async mounted() {
      this.$nextTick().then(() => this.resize?.());

      await Promise.allSettled([this.$nextTick(), this.state.mounted]);
      for (const input of this.state.forminputs) {
        await this.initDateTimeField(input);
      }
      await this.$nextTick();
      this.syncSelectInputs();
    },

    beforeDestroy() {
      GUI.off('resize', this.delayResize);
      this.delayResize = null;
      this.delayTime   = null;

      this.state.forminputs.forEach(input => {
        clearTimeout(input._xSelectSearchTimer);
        input._xSelectSearchRequest = (input._xSelectSearchRequest || 0) + 1;
      });
      this.search_layers.forEach(l => l.off('filtertokenchange', this.reloadSearchInputs));
    }

  };


/* template */
var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"disabled",rawName:"v-disabled",value:(_vm.state.searching || _vm.loading || _vm.reload),expression:"state.searching || loading || reload"}],staticClass:"g3w-search-panel form-group"},[(_vm.state.searching || _vm.loading || _vm.reload)?_c('div',{staticClass:"bar-loader",staticStyle:{"border":"0"}}):_vm._e(),_vm._v(" "),_c('h4',[_c('b',[_vm._v(_vm._s(_vm.state.title))])]),_vm._v(" "),(_vm.filterlayers.length > 0)?_c('section',{staticStyle:{"display":"flex","justify-content":"space-between"},attrs:{"id":"g3w-search-filter-layers"}},[_c('div',{staticStyle:{"color":"#FFF","text-align":"justify","position":"relative","border-radius":"3px","margin":"5px 2px 5px 2px","white-space":"pre-line","background-color":"#384246 !important"}},[_c('span',{staticStyle:{"text-align":"center","font-size":"0.7em","margin-top":"-4px","margin-left":"-4px","background-color":"var(--bgcolor)","font-weight":"bold","color":"#fff","position":"absolute","top":"0","left":"0","width":"15px","height":"15px","border":"1px solid #fff","border-radius":"50%"}},[_vm._v("i")]),_vm._v(" "),_c('div',{directives:[{name:"t",rawName:"v-t",value:('Search values are limited based on the active filter. Remove the filter to search all data.'),expression:"'Search values are limited based on the active filter. Remove the filter to search all data.'"}],staticStyle:{"max-height":"200px","padding":"10px","overflow-y":"auto"}})]),_vm._v(" "),_c('button',{staticClass:"btn skin-border-color",staticStyle:{"background-color":"transparent","margin":"5px 0"},attrs:{"title":"Remove Filter","data-placement":"left"},on:{"click":function($event){$event.stopPropagation();return _vm.clearFilters.apply(null, arguments)}}},[_c('i',{staticClass:"fas fa-broom skin-color",attrs:{"aria-hidden":"true"}})])]):_vm._e(),_vm._v(" "),_vm._t("tools"),_vm._v(" "),_vm._t("form",function(){return [_c('form',{staticClass:"g3w-search-form"},[_vm._l((_vm.state.forminputs),function(input){return _c('div',{key:input.id,staticClass:"form-group"},[('numberfield' === input.type || ('textfield' === input.type && 'Range' === input.widget_type))?_c('div',{staticClass:"numeric"},[_c('label',{staticClass:"search-label",attrs:{"for":input.id}},[_c('span',[_vm._v(_vm._s(input.label || input.attribute))]),_vm._v(" "),_c('span',{staticClass:"skin-color"},[_vm._v(_vm._s(_vm.getLabelOperator(input.operator)))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(input.value),expression:"input.value"}],staticClass:"form-control",attrs:{"type":"number","min":"0","id":input.id},domProps:{"value":(input.value)},on:{"change":function($event){return _vm.changeInput(input)},"input":[function($event){if($event.target.composing)return;_vm.$set(input, "value", $event.target.value)},function($event){return _vm.changeInput(input)}]}})]):(['textfield', 'textField'].includes(input.type))?_c('div',{staticClass:"form-item-search text"},[_c('label',{staticClass:"search-label",attrs:{"for":input.id}},[_c('span',[_vm._v(_vm._s(input.label || input.attribute))]),_vm._v(" "),_c('span',{staticClass:"skin-color"},[_vm._v(_vm._s(_vm.getLabelOperator(input.operator)))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(input.value),expression:"input.value"}],staticClass:"form-control",attrs:{"type":"text","id":input.id},domProps:{"value":(input.value)},on:{"focus":_vm.onFocus,"change":function($event){return _vm.changeInput(input)},"input":function($event){if($event.target.composing)return;_vm.$set(input, "value", $event.target.value)}}})]):(['selectfield', 'autocompletefield'].includes(input.type))?_c('div',{directives:[{name:"disabled",rawName:"v-disabled",value:(_vm.state.loading[input.dependance] || input.loading || input.disabled),expression:"state.loading[input.dependance] || input.loading || input.disabled"}],staticClass:"text"},[_c('label',{staticClass:"search-label",attrs:{"for":input.id}},[_c('span',[_vm._v(_vm._s(input.label || input.attribute))]),_vm._v(" "),_c('span',{staticClass:"skin-color"},[_vm._v(_vm._s(_vm.getLabelOperator(input.operator)))])]),_vm._v(" "),(input.dependance && (_vm.state.loading[input.dependance] || input.loading))?_c('div',{staticClass:"bar-loader",staticStyle:{"border":"0"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"search-select-control"},[_c('x-select',{attrs:{"data-input-id":input.id,"value":_vm.getSelectInputValue(input),"multiple":'in' === input.operator,"searchable":true,"disabled":input.disabled || input.loading},on:{"change":function($event){return _vm.onSelectInputChange(input, $event)},"search-input":function($event){return _vm.searchAutocomplete(input, $event)},"!click":function($event){return _vm.resetAutocompleteStatus(input, $event)},"!keydown":function($event){return _vm.resetAutocompleteStatus(input, $event)}}},_vm._l((input.values),function(opt){return _c('x-option',{key:opt.value,attrs:{"value":_vm.getSelectInputOptionValue(opt.value)}},[(_vm.allvalue === opt.value)?_c('span',{directives:[{name:"t",rawName:"v-t",value:('sdk.search.all'),expression:"'sdk.search.all'"}]}):_c('span',[_vm._v(_vm._s(opt.key))])])}),1),_vm._v(" "),('autocompletefield' === input.type && 'in' !== input.operator && ![null, undefined, _vm.allvalue].includes(input.value))?_c('button',{staticClass:"btn btn-default search-select-clear",attrs:{"type":"button","title":_vm.$t('Clear Selection'),"aria-label":_vm.$t('Clear Selection')},on:{"click":function($event){return _vm.clearAutocomplete(input)}}},[_c('i',{staticClass:"fas fa-times",attrs:{"aria-hidden":"true"}})]):_vm._e()],1)]):('datetimefield' === input.type)?_c('div',{directives:[{name:"disabled",rawName:"v-disabled",value:(_vm.state.loading[input.dependance] || false),expression:"state.loading[input.dependance] || false"}],staticClass:"text"},[_c('label',{staticClass:"search-label",attrs:{"for":input.id}},[_c('span',[_vm._v(_vm._s(input.label || input.attribute))]),_vm._v(" "),_c('span',{staticClass:"skin-color"},[_vm._v(_vm._s(_vm.getLabelOperator(input.operator)))])]),_vm._v(" "),_c('div',{ref:'date_' + input.id,refInFor:true,staticClass:"input-group date"},[_c('input',{staticClass:"form-control",attrs:{"id":input.id,"type":"text"}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon skin-color",staticStyle:{"cursor":"pointer"}},[_c('span',{class:input.options.format.time ? 'far fa-clock': 'fas fa-calendar-alt'})])])]):_vm._e(),_vm._v(" "),_c('sub',[_vm._v(_vm._s(input.options.description))]),_vm._v(" "),(_vm.is_staff)?_c('details',{staticStyle:{"cursor":"pointer","user-select":"none","margin-top":".5em"}},[_c('ul',{staticStyle:{"font-size":"80%","padding-left":"15px","font-family":"monospace","white-space":"nowrap","overflow-x":"auto","scrollbar-width":"thin"}},[_c('li',[_c('b',{staticClass:"skin-color"},[_vm._v(_vm._s(input.type))])]),_vm._v(" "),_c('li',[_c('b',{staticClass:"skin-color"},[_vm._v(_vm._s(input.widget_type))]),(input.options.value)?_c('span',[_vm._v(": {"),_c('br'),_vm._v("  key: \""+_vm._s(input.options.key)+"\","),_c('br'),_vm._v("  value: \""+_vm._s(input.options.value)+"\""),_c('br'),_vm._v("}")]):_vm._e()]),_vm._v(" "),(input.options.layer_id)?_c('li',[_c('b',{staticClass:"skin-color"},[_vm._v("layer_id:")]),_vm._v(" \""+_vm._s(input.options.layer_id)+"\"")]):_vm._e(),_vm._v(" "),(input.dependance)?_c('li',[_c('b',{staticClass:"skin-color"},[_vm._v("depends_on:")]),_vm._v(" \""+_vm._s(input.dependance)+"\"")]):_vm._e(),_vm._v(" "),(input.dependance)?_c('li',[_c('b',{staticClass:"skin-color"},[_vm._v("strict:")]),_vm._v(" "+_vm._s(input.dependance_strict))]):_vm._e()])]):_vm._e(),_vm._v(" "),(input.logicop)?_c('div',{staticClass:"search-logicop skin-border-color"},[_c('h4',[_vm._v(_vm._s(input.logicop))])]):_vm._e()])}),_vm._v(" "),_c('div',{directives:[{name:"disabled",rawName:"v-disabled",value:('data' !== _vm.state.return),expression:"'data' !== state.return"}],staticClass:"form-group"},[_c('label',{staticStyle:{"display":"block"},attrs:{"title":"Whether automatically filter geometries displayed within the map<br>in order to show only those related to current search results.","data-placement":"right"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.autofilter),expression:"autofilter"}],staticStyle:{"margin":"0"},attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.autofilter)?_vm._i(_vm.autofilter,null)>-1:(_vm.autofilter)},on:{"change":function($event){var $$a=_vm.autofilter,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.autofilter=$$a.concat([$$v]))}else{$$i>-1&&(_vm.autofilter=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.autofilter=$$c}}}}),_vm._v(" "),_c('span',{directives:[{name:"t",rawName:"v-t",value:('Filter results'),expression:"'Filter results'"}]}),_vm._v(" "),_c('i',{staticClass:"fa fa-filter fa-pull-right",style:({ opacity: _vm.state.autofilter.value ? 1 : .5 })})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{staticClass:"btn btn-block pull-right",attrs:{"id":"dosearch"},on:{"click":function($event){$event.stopPropagation();return _vm.doSearch.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('dosearch')))])])],2)]}),_vm._v(" "),_vm._t("footer"),_vm._v(" "),(_vm.layers_url)?_c('div',{staticStyle:{"padding-top":"5em"}},[_c('b',[_c('a',{attrs:{"href":_vm.layers_url,"target":"_blank"}},[_vm._v(_vm._s(_vm.$t('Edit in admin')))])])]):_vm._e()],2)
}
var staticRenderFns = []

const __vue_render__ = render;
const __vue_staticRenderFns__ = staticRenderFns;

const __vue_component__ = __vue_script__;
__vue_component__.render = __vue_render__;
__vue_component__.staticRenderFns = __vue_staticRenderFns__;
__vue_component__._compiled = true;
__vue_component__.__file = "/home/volterra79/G3W-SUITE/g3w-client/src/components/SearchPanel.vue";
__vue_component__._scopeId = "data-v-6e141a4e";
/* style inject */
import __vue_create_injector__ from 'g3w-vue:style-injector';
[{"id":"6e141a4e-0","css":".search-select-control[data-v-6e141a4e]{display:flex;align-items:center;gap:4px}.search-select-control x-select[data-v-6e141a4e]{flex:1;min-width:0;color:#333}.search-select-clear[data-v-6e141a4e]{flex:0 0 34px;height:34px;padding:0}.g3w-search-form label[data-v-6e141a4e]{color:#fff}.g3w-search-form .search-logicop[data-v-6e141a4e]{width:100%;position:relative;display:flex;justify-content:center;margin-bottom:15px;margin-top:30px;border-bottom:1px solid}.g3w-search-form .search-logicop h4[data-v-6e141a4e]{font-weight:700;position:absolute;padding:5px;top:-24px;background:var(--bgcolor)}#dosearch[data-v-6e141a4e]{color:#fff;font-weight:700;margin-top:15px;background-color:var(--skin-color)}#dosearch[data-v-6e141a4e]:hover{color:#fff}.search-label[data-v-6e141a4e]{width:100%;display:flex;justify-content:space-between}.search-label .skin-color[data-v-6e141a4e]{font-family:monospace}\n","media":"","filename":"src/components/SearchPanel.vue"}].forEach(__vue_create_injector__());
export default __vue_component__;